import { all, fork } from 'redux-saga/effects';

import AnalyticsOverviewSaga from '@host-panel/analytics/overview/state/analytics-saga';

import { settingsSagas } from '../../../settings/settingsSagas';
import { tenantConfigSagas } from '../../tenant-config/tenantConfigSagas';
import { featuresSagas } from '../../../features/featuresSagas';
import { usersSagas } from '../../../users/usersSagas';
import { moderationSaga } from '../../components/moderation-v2/comments-and-posts/state/actions';
import { analyticsSagas } from '../../../analytics/analyticsSagas';
import { spotsSagas } from '../../../spots/spotsSagas';

const SAGAS = [
  AnalyticsOverviewSaga,
  moderationSaga,
  settingsSagas,
  featuresSagas,
  tenantConfigSagas,
  analyticsSagas,
  usersSagas,
  spotsSagas
];

export default function* rootSaga() {
  yield all(SAGAS.map(saga => fork(saga)));
}
